import { css } from '@emotion/react';
import { styled } from '@mui/joy';
import type { ComponentPropsWithoutRef } from 'react';
import { forwardRef } from 'react';

import { MAIN_BREAKPOINT } from '@/modules/MAIN_BREAKPOINT';

const StyledImg = styled('img')<{ $size: 'xs' | 'sm' | 'md' | 'lg' }>(({ theme, $size }) => {
  const sizeLg = { xs: 7, sm: 10, md: 12, lg: 15 }[$size];
  const sizeXl = { xs: 7, sm: 13, md: 15, lg: 15 }[$size];

  return css`
    display: block;
    width: ${theme.spacing(7)};
    height: ${theme.spacing(7)};
    object-fit: cover;
    position: relative;
    border-radius: 10%;
    transition: transform 200ms ease;

    ${theme.breakpoints.up(MAIN_BREAKPOINT)} {
      width: ${theme.spacing(sizeLg)};
      height: ${theme.spacing(sizeLg)};
    }

    ${theme.breakpoints.up('xl')} {
      width: ${theme.spacing(sizeXl)};
      height: ${theme.spacing(sizeXl)};
    }
  `;
});

export const SignImageCircle = forwardRef<
  HTMLImageElement,
  ComponentPropsWithoutRef<typeof StyledImg> & { $size: 'xs' | 'sm' | 'md' | 'lg' }
>((props, ref) => <StyledImg ref={ref} alt="Bild des Verkehrszeichens" {...props} />);
